import WeatherPage from '../Shared/WeatherPage'
export default function AdminWeather() {
  return <WeatherPage isInstructor={false} />
}
